<script>
import Form from '@classes/Form'
import { healthRecordService } from '@services/HealthRecordService'
import { medicalVisitService } from '@services/MedicalVisitService'
import { medicalDateFormatter, isBeforeDate } from '@utils/medical-date'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import hrMixin from '@src/mixins/hr-mixin.vue'
import MedicalDatePickerDialog from '@components/dialogs/medical-date-picker-dialog.vue'
import store from '@state/store'
import ComboBox from '@components/combo-box.vue'
export default {
  page: {
    title: 'Medical Visit Editor',
    meta: [{ name: 'description', content: 'The Medical Visit Editor page.' }],
  },
  components: {
    MedicalDatePickerDialog,
    ComboBox,
  },
  mixins: [hrMixin],
  props: {
    formDialog: {
      type: Boolean,
      default: false,
    },
    formChanged: {
      type: Boolean,
      default: false,
    },
    formSaved: {
      type: Boolean,
      default: false,
    },
    formSavedAnother: {
      type: Boolean,
      default: false,
    },
    attachmentDeleted: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    resource: {
      type: String,
      default: 'medicalvisit',
    },
    show: {
      type: Boolean,
      default: false,
    },
    unauth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      medicalVisitForm: new Form({
        date: null,
        date_part: '',
        professional: '',
        type_of_visit: '',
        reason: '',
        symptoms: '',
        findings: '',
        diagnosis: '',
        treatment: '',
        note: '',
        private: false,
      }),
      medicalDatePickerDialog: false,
      medicalVisitError: null,
      attachments: [],
      originalAttachments: [],
      medicalVisitsIcons: {
        'initial-visit': 'mdi-stethoscope',
        'new-symptom': 'mdi-note-plus-outline',
        'follow-up': 'mdi-autorenew',
        routine: 'mdi-calendar-text',
        emergency: 'mdi-plus-box',
      },
      showHRActions: true,
    }
  },
  computed: {
    ...authComputed,
    ...optionsComputed,
    medicalVisits() {
      return this.getMedicalVisitOptions?.reason
        ? this.getMedicalVisitOptions.reason
        : []
    },
    typeOfVisits() {
      return this.getMedicalVisitOptions?.type_of_visit
        ? this.getMedicalVisitOptions.type_of_visit
        : []
    },
    canSaveMedicalVisit() {
      if (
        (this.medicalVisitForm.date ||
          this.medicalVisitForm.date_part === 'past') &&
        this.medicalVisitForm.type_of_visit &&
        this.medicalVisitForm.reason &&
        this.medicalVisitError === null &&
        this.dateError === null
      ) {
        return true
      }
      return false
    },
  },
  async mounted() {
    try {
      if (!this.getMedicalVisitOptions) {
        const medicalVisitOptions = (await medicalVisitService.options()).data
        if (medicalVisitOptions) {
          store.dispatch('options/setMedicalVisitOptions', medicalVisitOptions)
        }
      }

      if (this.edit) {
        if (this.item.patient_id !== null) {
          this.showHRActions = false
        }
        this.itemToForm(this.resource, this.item)
      }
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
    ...authMethods,
    setMedicalDate(medicalDate, past) {
      const field = this.medicalDatePickerName
      const fieldPart = this.medicalDatePickerName + '_part'

      const medicalDateObject = medicalDateFormatter(medicalDate)

      this.medicalVisitForm[field] = medicalDateObject.date
      this.medicalVisitForm[fieldPart] = this.determinePast(
        past,
        medicalDateObject
      )
      this.medicalDatePickerDialog = false
    },
    clearForm() {
      this.medicalVisitForm.reset()
      this.message = false
      this.attachments = []
      this.isAnother = false
      this.isContinue = false
      this.medicalVisitError = null
      this.dateError = null
    },
    async getMedicalVisitResponse() {
      if (this.edit) {
        return (
          await healthRecordService.update(
            this.item.hr_id,
            this.medicalVisitForm.removeEmptyStringFromData()
          )
        ).data
      } else {
        return (
          await medicalVisitService.create(
            this.medicalVisitForm.removeEmptyFromData()
          )
        ).data
      }
    },
    async deleteAttachment(id) {
      try {
        const response = await medicalVisitService.attachmentDelete(id)
        if (response) {
          this.originalAttachments = this.originalAttachments.filter(function (
            obj
          ) {
            return obj.id !== id
          })
          this.$emit('update:attachmentDeleted', true)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    setErrors(error) {
      this.medicalVisitForm.onFail(error.response.data)
      if (this.hasResponse) {
        this.message = true
        if (this.formDialog) {
          this.$emit('update:formSaved', true)
        }
      }
      this.medicalVisitError = error
    },
    async tryToSave(action) {
      this.resetFlagsAndErrors('medicalVisitError', action)
      try {
        if (
          this.medicalVisitForm.date &&
          isBeforeDate(
            this.medicalVisitForm.date,
            new Date().toISOString().split('T')[0]
          )
        ) {
          this.dateError = this.$t('start-after-today')
          this.scrollToErrors()
          return
        }
        const response = await this.getMedicalVisitResponse()

        if (response) {
          if (document.getElementById('getAllData')) this.hasResponse = true
          let responseAttachments

          if (this.attachments.length > 0) {
            responseAttachments = (
              await medicalVisitService.attachments(
                this.attachments,
                response.hr_id,
                'medicalvisit'
              )
            ).data

            console.warn(responseAttachments)
          }

          await this.fetchWizardData()

          this.message = true
          if (
            action === 'continue' &&
            store.state.calender.addNewRecord === 'true'
          ) {
            this.$emit('update:formSaved', true)
            this.$emit('close-dialog')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'continue') {
            this.$emit('update:formSaved', true)
            this.edit ? this.$emit('close-dialog') : this.$emit('back')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'another') {
            this.$emit('update:formSavedAnother', true)
            this.clearForm()
            this.$emit('add-another')
            if (document.getElementById('updateGetAllData'))
              document.getElementById('updateGetAllData').click()
          }
        }
      } catch (error) {
        console.warn(error)
        this.setErrors(error)
        this.isAnother = false
        this.isContinue = false
        this.scrollToErrors()
      } finally {
        this.tryingToSave = false
      }
    },
    itemToForm(res, item) {
      if (item.record.date) {
        this.medicalVisitForm.date = item.record.date
      }
      this.medicalVisitForm.date_part = item.record.date_part
      this.medicalVisitForm.professional = item.record.professional
      this.medicalVisitForm.type_of_visit = item.record.type_of_visit
      this.medicalVisitForm.reason = item.record.reason.key
      this.medicalVisitForm.symptoms = item.record.symptoms
      this.medicalVisitForm.findings = item.record.findings
      this.medicalVisitForm.diagnosis = item.record.diagnosis
      this.medicalVisitForm.treatment = item.record.treatment
      this.medicalVisitForm.note = item.note
      this.medicalVisitForm.private = item.private
      this.originalAttachments = item.attachments.map((element) => {
        return { ...element }
      })
    },
  },
}
</script>

<template>
  <v-container @dragover.prevent @drop="onDrop">
    <v-row
      no-gutters
      :class="$style.hrHeader"
      class="primary--text mt-1"
      justify="center"
    >
      <div class="mr-4">
        <v-img
          :src="
            require('@assets/images/safehaven/health-record-icons/healthcare-visits.svg')
          "
          height="30"
          width="30"
          contain
        ></v-img>
      </div>
      {{ $t('health-record.medical-visits.form_title') }}
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-10 offblack--text"
      no-gutters
      justify="center"
    >
      Which healthcare provider did you meet with?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <v-text-field
        v-model="medicalVisitForm.professional"
        placeholder="e.g. Dr Juliette Holmes"
        :class="$style.hrTextField"
        filled
        background-color="input"
        :disabled="show"
        rounded
      />
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      When was this visit?
    </v-row>
    <v-row v-if="dateError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{ dateError }}</p>
      </v-col>
    </v-row>
    <v-row class="mt-10" no-gutters justify="center">
      <div
        :class="mobile ? $style.medicalDateDivMobile : $style.medicalDateDiv"
      >
        <MedicalDatePickerDialog
          :key="'medicalVisitDate-1'"
          :dialog.sync="medicalDatePickerDialog"
          :title="'health-record.medical-visits.visit-date'"
          :field="medicalVisitForm.date"
          :part="medicalVisitForm.date_part"
          filled
          :disabled="show"
          background-color="input"
          :error-messages="
            medicalVisitForm.errors.has('date')
              ? 'Visit Date: ' + medicalVisitForm.errors.get('date')
              : ''
          "
          @input="clearErrors('date', 'medicalVisitForm', 'medicalVisitError')"
          @setMedicalDate="setMedicalDate"
          @showMedicalDate="showMedicalDate('date')"
        />
      </div>
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-10 offblack--text"
      no-gutters
      justify="center"
    >
      What type of visit was this?
    </v-row>

    <v-row class="mt-10" no-gutters>
      <div class="mx-auto" :class="$style.hrInputDiv">
        <v-select
          v-model="medicalVisitForm.type_of_visit"
          class="medicalVisitTypeOfVisit"
          attach=".medicalVisitTypeOfVisit"
          :items="typeOfVisits"
          item-text="value"
          item-value="key"
          placeholder="Select Type"
          clearable
          rounded
          filled
          background-color="input"
          :class="$style.hrSelect"
          :disabled="show"
        />
      </div>
      <v-col
        v-if="
          !medicalVisitForm.type_of_visit &&
          medicalVisitForm.errors.has('type_of_visit')
        "
        class="text-center"
        :class="['error--text', $style.errorText]"
        cols="12"
      >
        Type of visit: {{ medicalVisitForm.errors.get('type_of_visit') }}
      </v-col>
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      What was the main reason of your visit?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <v-item-group v-model="medicalVisitForm.reason" class="mb-10">
        <v-container :class="$style.cardsContainer">
          <v-row>
            <v-col
              v-for="(cat, index) in medicalVisits"
              :key="cat + index"
              class="d-flex"
              :class="{
                'justify-md-center': index < 3 && !mobile,
                'justify-md-end': index === 3 && !mobile,
                'justify-center': mobile,
                'pr-md-15': index === 3 && !mobile,
                'pl-md-15': index === 4 && !mobile,
              }"
              cols="12"
              :md="index < 3 ? 4 : 6"
            >
              <v-item v-slot="{ active, toggle }" :value="cat.key">
                <v-sheet
                  class="d-flex align-center clickable"
                  :class="[
                    active ? [$style.hrCard, $style.activeCard] : $style.hrCard,
                    show ? $style.disabledClass : '',
                  ]"
                  width="156"
                  height="160"
                  flat
                  :color="active ? '#EBECFE' : 'background'"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-container fluid class="fill-height pa-0">
                      <v-row class="mb-4" justify="center" no-gutters>
                        <v-icon v-show="!active" color="placehold" large>
                          {{ medicalVisitsIcons[cat.key] }}
                        </v-icon>
                        <v-img
                          v-show="active"
                          contain
                          max-height="36"
                          max-width="36"
                          :src="require('@assets/images/checkmark.svg')"
                        ></v-img>
                      </v-row>
                      <v-row
                        :class="$style.cardText"
                        justify="center"
                        class="label--text"
                        no-gutters
                      >
                        {{ cat.value }}</v-row
                      >
                    </v-container>
                  </v-card-text>
                </v-sheet>
              </v-item>
            </v-col>
            <v-col
              v-if="
                !medicalVisitForm.reason &&
                medicalVisitForm.errors.has('reason')
              "
              class="text-center"
              :class="['error--text', $style.errorText]"
              cols="12"
            >
              Reason: {{ medicalVisitForm.errors.get('reason') }}
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      What's the primary symptom?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <div :class="$style.hrComboBoxContainer">
        <ComboBox
          :key="'medical-visit-combo-1'"
          :disabled="show"
          :combo-class="'medical-visit-combo-1'"
          :value.sync="medicalVisitForm.symptoms"
          :placeholder="$t('health-record.medical-visits.symptoms')"
          :fetch-url="unauth ? null : '/api/v1/hr/choices/symptom/'"
          rounded
          filled
          background-color="input"
          :class="$style.hrComboBox"
        ></ComboBox>
      </div>
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      Any new findings you'd like to note?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <v-text-field
        v-model="medicalVisitForm.findings"
        :disabled="show"
        :placeholder="$t('health-record.medical-visits.findings')"
        :class="$style.hrTextField"
        rounded
        filled
        background-color="input"
      />
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      What was the diagnosis made during the visit?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <div :class="$style.hrComboBoxContainer">
        <ComboBox
          :key="'medical-visit-combo-2'"
          :disabled="show"
          :combo-class="'medical-visit-combo-2'"
          :value.sync="medicalVisitForm.diagnosis"
          :placeholder="$t('health-record.medical-visits.diagnosis')"
          fetch-url="/api/v1/hr/choices/condition/"
          rounded
          filled
          background-color="input"
          :class="$style.hrComboBox"
        ></ComboBox>
      </div>
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      What was the treatment?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <v-text-field
        v-model="medicalVisitForm.treatment"
        :disabled="show"
        placeholder="Treatment"
        :class="$style.hrTextField"
        rounded
        filled
        background-color="input"
      />
    </v-row>

    <v-row class="mt-7">
      <div :class="$style.hrQuestionFull" class="offblack--text"
        >Any additional files or notes you'd like to include?
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <SpeechToText
          :key="'social-history-2'"
          :disabled="show"
          :value.sync="medicalVisitForm.note"
          auto-grow
          rounded
          :class="$style.hrSpeechToText"
          :placeholder="$t('health-record.medical-visits.note')"
        ></SpeechToText>
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <FileUpload
          :key="'social-history-3'"
          :disabled="show"
          icon
          :height="200"
          :multiple="true"
          :files.sync="attachments"
          :non-draggable="true"
        ></FileUpload>
      </div>
    </v-row>

    <v-row v-if="edit" class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <AttachmentList
          :disabled="show"
          :attachments="originalAttachments"
          @delete-attachment="deleteAttachment"
        ></AttachmentList>
      </div>
    </v-row>

    <ForMyEyesOnly v-if="!show" :value.sync="medicalVisitForm.private" />
    <div v-if="showHRActions">
      <HrActions
        :can-save="canSaveMedicalVisit"
        :is-another="isAnother"
        :is-continue="isContinue"
        :trying-to-save="tryingToSave"
        :trying-to-delete="tryingToDelete"
        :edit="edit"
        @go-back="goBack"
        @try-to-save="tryToSave"
        @try-to-delete="prepareDeletion"
      />
    </div>

    <v-row v-if="medicalVisitError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{
          $t('health-record.medical-visits.error')
        }}</p>
        <div v-if="medicalVisitForm.errors.has('non_field_errors')">
          <div
            v-for="(error, index) in medicalVisitForm.errors.getNonField(
              // eslint-disable-next-line vue/comma-dangle
              'non_field_errors'
            )"
            :key="'error-non-field' + index"
          >
            <p class="error--text">{{ error }}</p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="message" class="ml-1">
      <p class="success--text">{{
        $t('health-record.medical-visits.message')
      }}</p>
    </v-row>
    <BaseConfirmDialog
      v-if="confirmDialog"
      :dialog="confirmDialog"
      :message="computedMessage"
      title="Delete Item"
      @cancel="cancel"
      @confirm="deleteItem"
    />
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.disabledClass {
  pointer-events: none;
}
.hrHeader {
  // styleName: Desktop/Display X-Small Bold;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestion {
  // styleName: Desktop/Display X-Small;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestionFull {
  // styleName: Desktop/Display X-Small;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrRadio {
  // styleName: Mobile / Display Small;
  font-family: $system-default-font-family;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: left;
  letter-spacing: 1px;
}
.hrComboBoxContainer {
  width: 394px;
}
.hrComboBox {
  border-radius: 15px !important;
}
.hrTextField {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrTextFieldCol {
  max-width: 200px !important;
  border-radius: 15px !important;
}
.hrAutoComplete {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrAutoCompleteCol {
  max-width: 200px !important;
  border-radius: 15px !important;
}
.hrSelect {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrInputDiv {
  width: 394px;
  border-radius: 15px !important;
}
.hrSpeechToText {
  max-width: 394px !important;
  background: $color-theme-light-input;
}
.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}
.hrCard {
  border-radius: 16px !important;
}
.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}
.hrButton {
  border-radius: 8px !important;
}
.medicalDateDiv {
  width: 394px;
  margin-right: auto;
  margin-left: auto;
}
.medicalDateDivMobile {
  width: 60%;
  margin-right: auto;
  margin-left: auto;
}
.errorText {
  font-size: 12px;
  color: #ca024f !important;
}
</style>
